import React from "react";
//import { Tooltip } from "mdbreact";

import "./DriveItemThumbnail.scss";
import "font-awesome/css/font-awesome.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
//import "mdbreact/dist/css/mdb.css";
class TooltipsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overflow : false
    };
    this.isTextOverflow = this.isTextOverflow.bind(this);
    this.checkOverflow = this.checkOverflow.bind(this);
  }

  componentDidMount() {
    this.checkOverflow();
  }

  isTextOverflow(element) {
    return element.scrollWidth > element.clientWidth;
  }

  checkOverflow() {
    const overflow = this.isTextOverflow(this.element);
    if (overflow !== this.state.overflow) {
      this.setState({ overflow: overflow });
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.state.overflow ? (
          // <Tooltip componentClass="opacity"  placement="bottom" tooltipContent={this.props.text}>
         <div>{this.props.text}</div>  
          // </Tooltip>
        ) : (
          <div className="opacity"
            ref={el => {
              this.element = el;
            }}
          >
            {this.props.text}
          </div>
        )}
      </div>
    );
  }
}
//height: calc(100vh - 37px - 60px - 30px);
export default TooltipsPage;



// WEBPACK FOOTER //
// ./src/widget/components/driveItemThumbnail/TooltipsPage.js